import { Alert, AlertTitle } from '@mui/material';

// One place for what each status means to the realtor and what they do next.
export const STATUS_COPY = {
  draft: { severity: 'info', title: 'Draft', body: 'Fill in the details and complete every checklist item, then submit for desk review.' },
  submitted: { severity: 'info', title: 'With Eqaya for desk review', body: 'Our team is checking each item of your dossier. You will be notified when it is approved or returned. Editing is locked; withdraw to make changes.' },
  changes_requested: { severity: 'warning', title: 'Changes requested', body: 'Fix the items marked below and submit again. Items already verified stay verified.' },
  desk_approved: { severity: 'success', title: 'Dossier approved', body: 'Next: an independent Eqaya Verification of the property. That step opens here shortly.' },
  verification_pending: { severity: 'info', title: 'Eqaya Verification in progress', body: 'Paid. An Eqaya verifier will visit the property and re-check the records; you will be notified at each step.' },
  verified: { severity: 'success', title: 'Eqaya Verified', body: 'Your listing has passed independent verification.' },
  published: { severity: 'success', title: 'Published', body: 'Buyers can see this listing.' },
  unpublished: { severity: 'warning', title: 'Unpublished', body: 'This listing is hidden from buyers.' },
  withdrawn: { severity: 'info', title: 'Withdrawn', body: 'You withdrew this listing. Create a new one to list the property again.' },
  rejected: { severity: 'error', title: 'Rejected by Eqaya', body: 'This listing cannot proceed. The reason is below.' },
  sold: { severity: 'info', title: 'Sold', body: 'Marked as sold.' },
};

// "Unpublished" means three very different things to the realtor: one they did,
// one they can pay to clear, and one only their agency's EAC standing clears.
export const UNPUBLISH_COPY = {
  manual: 'You hid this listing. Publish it again when ready.',
  reverification: 'Hidden until a new Eqaya Verification is paid for.',
  eac_standing: 'This listing is hidden from buyers. Your agency\'s EAC standing lapsed — fix that on your profile.',
};

export const STATUS_CHIP_COLOR = { draft: 'default', submitted: 'info', changes_requested: 'warning', desk_approved: 'success', verification_pending: 'info', verified: 'success', published: 'success', unpublished: 'warning', withdrawn: 'default', rejected: 'error', sold: 'default' };

export default function ListingStatusBanner({ listing }) {
  const c = STATUS_COPY[listing?.status] || STATUS_COPY.draft;
  const body = (listing?.status === 'unpublished' && UNPUBLISH_COPY[listing?.unpublish_reason]) || c.body;
  return (
    <Alert severity={c.severity} sx={{ mb: 3 }}>
      <AlertTitle>{c.title}</AlertTitle>
      {body}
      {listing?.desk_review_notes && ['changes_requested', 'rejected'].includes(listing.status) && <div style={{ marginTop: 8 }}><strong>From Eqaya:</strong> {listing.desk_review_notes}</div>}
    </Alert>
  );
}
